import script from "./VTitledValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./VTitledValue.vue?vue&type=script&setup=true&lang=ts"

import "./VTitledValue.vue?vue&type=style&index=0&id=435196ca&lang=scss"

const __exports__ = script;

export default __exports__